export default {"src":"/_next/static/media/Group-214114-1.6c870a25.svg","height":126,"width":126};